











































































































































import {
  Component,
  Emit,
  Inject,
  Model,
  Prop,
  Provide,
  Vue,
  Watch
} from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ScrollView from "@/components/scroll/flipScroll.vue";
import PopGallery from "@/components/popGallery/popGallery.vue";
import Button from "@/components/button/Button.vue";
import * as types from "@/store/constants/types";
import generalStatusHelper from "@/utils/generalUtils";
import NumUtils from "@/utils/numUtils";
import BakcPress from "@/utils/backPress";
import { ACTION_SHEET_KEY } from "@/utils/backPress";
@Component({
  components: {
    Button,
    PopGallery,
    ScrollView
  }
})
export default class InsUserPopGallery extends Vue {
  @Getter(types.GETTER_CURRENT_INS_POST_ID)
  private currentPostId: any;
  @Getter(types.GETTER_CURRENT_INS_VIEW_ID)
  private currentViewId: any;
  @Getter(types.GETTER_CURRENT_INS_MEDIA_LIST_INFO)
  private currentMediaListInfo: any;
  @Mutation(types.CHANGE_CURRENT_INS_POST_ID)
  private changeCurrenInsPostId: any;
  @Mutation(types.CHANGE_CURRENT_INS_VIEW_ID)
  private changeCurrenInsViewId: any;
  @Getter(types.GETTER_CURRENT_INS_USER_ID)
  private currentUserId: any;
  @Getter(types.GETTER_CURRENT_INS_USER_INFO)
  private currentInsUserInfo: any;
  @Action(types.UPDATE_USER_INS_POST)
  private updateUserInsPost: any;
  @Action(types.REQUEST_INS_USER_MEDIA_LIST_DATA_MORE)
  private requestPostMore: any;
  @Prop({ default: false })
  private value?: boolean;
  @Prop({ default: "like" })
  private type?: string;

  private popShow: boolean = false;
  private tabStatus: string = "list"; //tab的两种状态
  private contentHeight: number = 284;
  private itemHeight: number = 84;
  private isPullUp: boolean = true;

  get currentMediaListInfoLength() {
    return this.currentMediaListInfo === null ||
      this.currentMediaListInfo === undefined
      ? 0
      : this.currentMediaListInfo.insMediaList.length;
  }

  get currentMediaListInfoList() {
    // return this.currentMediaListInfo === null ||
    //   this.currentMediaListInfo === undefined
    //   ? []
    //   : this.type === "view"
    //     ? this.currentMediaListInfo.insMediaList.filter((media: any) => {
    //         console.log("media.media_type:", media.media_type);
    //         return media.media_type === 2;
    //       })
    //     : this.currentMediaListInfo.insMediaList;
    return this.currentMediaListInfo === null ||
      this.currentMediaListInfo === undefined
      ? []
      : this.currentMediaListInfo.insMediaList;
  }

  @Watch("value", { immediate: true })
  private changePop(val: boolean, oldVal: boolean) {
    this.popShow = val;
  }

  @Watch("popShow", { immediate: true })
  private change(val: boolean, oldVal: boolean) {
    this.$emit("input", val);

    if (val) {
      BakcPress.listen({
        key: ACTION_SHEET_KEY,
        fn: () => {
          this.$emit("input", false);
        }
      });
    } else {
      BakcPress.destroy(ACTION_SHEET_KEY);
    }
  }

  @Watch("currentMediaListInfoLength", { immediate: true })
  private userListchange(val: number, oldVal: number) {
    console.log("userListchange :", val, oldVal);
    this.contentHeight = val * this.itemHeight;
  }

  get generalStatusHelper() {
    return generalStatusHelper;
  }

  get simplify() {
    return NumUtils.simplify;
  }

  private activeItem(item: any) {
    if (this.type === "view") {
      return this.currentViewId === item.id;
    } else {
      return this.currentPostId === item.id;
    }
  }

  private clickItem(item: any, index: number) {
    if (item.media_type === 2) {
      //是view类型的话，同时需要改变当时的view id
      this.changeCurrenInsViewId(item);
      this.changeCurrenInsPostId(item);
    } else {
      if (this.type === "view") {
        this.$Toast.show({
          type: "warning",
          content: "Please choose a video",
          duration: 1500
        });
        return;
      } else {
        this.changeCurrenInsPostId(item);
      }
    }
    this.popShow = false;
  }

  private clickList() {
    this.tabStatus = "list";
    this.contentHeight = this.currentMediaListInfoLength * this.itemHeight;
  }

  private clickGrid() {
    this.tabStatus = "grid";
    //要改变
    this.contentHeight =
      this.currentMediaListInfoLength * document.body.clientWidth * 0.33 + 25;
  }

  private clickChangeUser() {
    console.log("clickChangeUser");
    this.$emit("clickChangeUser");
  }

  private onPullingDown(done: any) {
    this.updateUserInsPost(this.currentUserId)
      .then((result: any) => {
        done();
      })
      .catch((error: any) => {
        done();
      });
  }

  private onPullingUp(done: any) {
    console.log("media onPullingUp");
    this.requestPostMore(this.currentUserId)
      .then((result: any) => {
        console.log("media onPullingUp result:", result);
        result ? done() : done(true);
      })
      .catch((error: any) => {
        console.log("media onPullingUp error:", error);
        done();
      });
  }
}
